import { render, staticRenderFns } from "./ResearchReport.vue?vue&type=template&id=a701765a&scoped=true"
import script from "./ResearchReport.vue?vue&type=script&lang=js"
export * from "./ResearchReport.vue?vue&type=script&lang=js"
import style0 from "./ResearchReport.vue?vue&type=style&index=0&id=a701765a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a701765a",
  null
  
)

export default component.exports